import { format, parseISO } from 'date-fns';

/** Legacy bare time strings → full ISO so ion-datetime can parse them. */
export const toParseableTimeIso = (v: string): string => {
    const s = String(v);
    if (s.includes('T')) {
        return s;
    }
    if (/^\d{2}:\d{2}/.test(s)) {
        return `${format(new Date(), 'yyyy-MM-dd')}T${s}`;
    }
    return s;
};

export const timePickerIsoValue = toParseableTimeIso;

/** Display time-only answers in 24-hour form (no offset suffix). */
export const formatTimeAttributeDisplay = (v: string): string => {
    if (!v) {
        return '';
    }
    try {
        return format(parseISO(toParseableTimeIso(String(v))), 'HH:mm:ss');
    } catch {
        return '';
    }
};
